const escolas_e_ensinos_ministrados = {
  path: "/relatorio-de-apoio-gerencial-escolas-ensinos-ministrados",
  redirect: "/relatorio-de-apoio-gerencial-escolas-ensinos-ministrados",
  meta: {
    breadCrumb:
      "Gerenciamento de Matrícula - Apoio Gerencial de Planejamento da Matrícula",
  },
  children: [
    {
      path: "/relatorio-de-apoio-gerencial-escolas-ensinos-ministrados",
      name: "relatorio_de_apoio_gerencial_escolas_ensinos-ministrados",
      meta: {
        allowedPermissions: ["estrutura_turma_listar_escolas_ensinos"],
      },
      component: () =>
        import(
          "@/views/RelatorioApoioGerencialEscolasEnsinosMinistrados/RelatorioApoioGerencialEscolasEnsinosMinistrados.vue"
        ),
    },
  ],
};

export { escolas_e_ensinos_ministrados };
